import classnames from 'classnames';
import { SyntheticEvent } from 'react';
import { Input, Icon } from 'semantic-ui-react';
import * as Styles from './password-input.module.less';

export interface PasswordInputInterface {
    name?: string;
    placeholder?: string;
    value: string;
    isPasswordVisible: boolean;
    togglePasswordVisibility: (
        event: SyntheticEvent<HTMLInputElement>,
        data: { checked?: boolean }
    ) => void;
    onChange: (event: SyntheticEvent<HTMLInputElement>, data: { value: string }) => void;
    isToggleVisible?: boolean;
    className?: string;
}

export const PasswordInput = (props: PasswordInputInterface) => {
    const togglePasswordVisibility = (e: SyntheticEvent<HTMLInputElement>) => {
        props.togglePasswordVisibility(e, { checked: !props.isPasswordVisible });
    };

    return (
        <div className={Styles.passwordInput}>
            <Input
                fluid
                name={props.name || 'password'}
                type={props.isPasswordVisible ? 'text' : 'password'}
                placeholder={props.placeholder || 'Password'}
                className={classnames(Styles.inputField, props.className)}
                value={props.value}
                onChange={props.onChange}
            />
            {props.value.length !== 0 &&
                (props.isToggleVisible || props.isToggleVisible === undefined) && (
                    <Icon
                        name="eye"
                        onClick={togglePasswordVisibility}
                        className={classnames(
                            Styles.passwordVisibilityButton,
                            props.isPasswordVisible && Styles.passwordVisibilityButtonActive
                        )}
                    />
                )}
        </div>
    );
};
